// extracted by mini-css-extract-plugin
export default {"notifierContainer":"ClientPage_notifierContainer__j+GTE"};